import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";
import { PublicType, ReceptionCount, ReceptionStatus, RoomType, UseCase } from "./RoomScheduleSettings";
import { RoomType as RoomScheduleRoomType, UseType } from "./Rooms";

/**
 * ### 他事業所連携メッセージ API 操作クラス
 */
export default class OtherOfficeRoomSchedules {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### GET OtherOfficeRoomSchedules
   */
  public async gets(userStore: LoginUser, year: number, month: number): Promise<Array<OtherOfficeRoomSchedulesGetModel>> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId,
      year: year,
      month: month
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.OtherOfficeRoomSchedules, formatParams);
    const response = await this.commonService.executeGet<Array<OtherOfficeRoomSchedulesGetModel>>(
      userStore,
      requestUrl,
      this.constructor.name,
      {},
      HitomeqErrorType.REQUEST_RETRY,
      0
    );
    return response.data;
  }
}

export interface OtherOfficeRoomSchedulesGetModel {
  /** 施設ID */
  facilityId: number;
  /** 施設名 */
  facilityName: string;
  /** 公開情報 */
  publicType: PublicType;
  /** 用途（家族連絡サービスの空床スケジュール） */
  useCasesForRoomSchedule: Array<UseCaseForRoomSchedule> | null;
  /** 用途（自分で設定した空床情報）*/
  useCasesForVacancySetting: Array<UseCaseForVacancySetting> | null;
  /** 空床情報設定の連絡事項 */
  message: string | null;
}

/** 空床スケジュールを使用する場合の用途 */
export interface UseCaseForRoomSchedule {
  /** 用途 */
  useType: UseType;
  /** 部屋情報 */
  rooms: Array<RoomForRoomSchedule>;
}
/** 空床スケジュールを使用する場合の部屋種別 */
export interface RoomForRoomSchedule {
  /** 部屋種別 */
  roomType: RoomScheduleRoomType;
  /** 日付ごとの予約可否 */
  days: Array<ReceptionStatus>;
}

/** 自分で設定を使用する場合の用途 */
export interface UseCaseForVacancySetting {
  /** 用途 */
  useCase: UseCase;
  /** 部屋情報 */
  rooms: Array<RoomForVacancySetting>;
}
/** 自分で設定を使用する場合の部屋種別 */
export interface RoomForVacancySetting {
  /** 部屋種別 */
  roomType: RoomType;
  /** 空床情報 */
  receptionStatus: ReceptionStatus;
  /** 空床情報（空床数） */
  receptionCount: ReceptionCount;
}
